'use strict';
/**
 * Import Babel Polyfill
 */

require("babel-polyfill");
/**
 * Load stylesheets (will be extracted with webpack)
 */


import '../scss/app.scss';
/**
 * Import
 */

require("./modules/topbar");

require("./modules/object-fit-polyfill");

require("./script");

import freeQuotePage from './modules/free-quote-page';
import stickySidebar from './modules/sticky-sidebar';
freeQuotePage();
stickySidebar();
/**
 * Vue components
 */

import Vue from 'vue';
import VueMq from 'vue-mq'; // import VueMenu from '../vue/menus/Menu.vue';

Vue.use(VueMq, {
  breakpoints: {
    sm: 768,
    md: 1280,
    lg: Infinity
  }
}); // new Vue({
//     el: '#menu',
//     render: h => h(VueMenu)
// });

/**
 * Portfolio archive:
 * Vue Application
 */

import Portfolio from '../vue/portolio/archive/Layout.vue';
var portfolioContainers = document.querySelectorAll('.app-portfolio');

if (portfolioContainers.length > 0) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = portfolioContainers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var portfolio = _step.value;
      new Vue({
        el: portfolio,
        render: function render(h) {
          return h(Portfolio);
        }
      });
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}